@if (captureSnapshot.processing) {
  <span> Processing... </span>
} @else {
  @if (canDownload) {
    <a href="#" (click)="onDownloadClick($event)">
      {{ captureSnapshot.filename }}
    </a>
  } @else {
    <span> {{ captureSnapshot.status | titlecase }} </span>
  }
}
